module.exports = __webpack_public_path__ + "292a341fed81ac07b1976541d2b8c308.svg";